import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {AuthenticationService} from "../../pages/services/authentication.service";
import {IResponseCentrosMedicos} from "../interfaces/centros-medicos.interface";
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ObtenerInstitucionesService {
  private apiUrl = environment.baseURL;

  constructor(private httpClient: HttpClient,
              private authService: AuthenticationService) {}

  getInstituciones(): Observable<IResponseCentrosMedicos> {
    const empresa = JSON.parse(sessionStorage.getItem('info') || '{}').empresa;
    const params = new HttpParams().set('idEmpresa', empresa[0].idEmpresa);
    return this.httpClient.get<IResponseCentrosMedicos>(this.apiUrl + 'datos-medicos/centros-medicos', {params});
  }

}
